(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    if (customElements.get('base-vimeo-video') === undefined && !('Vimeo_loading' in window)) {
        window['Vimeo_loading'] = 1;
        import("https://cdnjs.cloudflare.com/ajax/libs/vimeo-player/2.13.0/player.es.min.js").then(Player => {
            delete window['Vimeo_loading'];
            customElements.define('base-vimeo-video', class extends HTMLElement {
                constructor() {
                    super();
                    if (!this.querySelector('.vimeo-target')) {
                        this.insertAdjacentHTML('afterbegin', '<div class="vimeo-target"></div>');
                    }
                    const target = this.querySelector('.vimeo-target');
                    this.player = new Player.default(target, {
                        id: this.getAttribute('video'),
                        width: 560,
                    });
                    this.player.on('play', () => {
                        this.dispatchEvent(new CustomEvent('play'));
                    });
                    this.player.on('pause', () => {
                        this.dispatchEvent(new CustomEvent('pause'));
                    });

                    // calculate and set aspect ratio of the element
                    Promise.all([this.player.getVideoHeight(), this.player.getVideoWidth()]).then(([height, width]) => {
                        if (height && width) {
                            target.style.aspectRatio = `${width} / ${height}`;
                        }
                    });
                }
                play() {
                    this.player.play();
                }
                pause() {
                    this.player.pause();
                }
            });
        });
    }
});


